import { useEffect, useRef } from 'react';
import { SimpleGrid } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useAddressStore } from '@/src/modules/auth/stores/use-address-store';
import { useGetProductList } from '@/src/modules/produk-kesehatan/hooks/use-get-product-list';
import { ApplicationError } from '../../errors';
import { ProductCard } from '../produk-kesehatan/product-list/ProductCard';
import { ProductCardSkeleton } from '../produk-kesehatan/product-list/ProductCardSkeleton';

export default function ProductGrid() {
  const { execute, data, isLoading, error } = useGetProductList();
  const PAGE_SIZE = 5;
  const products = data?.data ?? [];
  const hasFetched = useRef(false);
  const coordLat = useAddressStore((s) => s.currentLat);
  const coordLong = useAddressStore((s) => s.currentLong);

  useEffect(() => {
    if (hasFetched.current) {
      return;
    }
    if (coordLat && coordLong) {
      hasFetched.current = true;
    }

    execute({
      offset: 1,
      size: PAGE_SIZE,
      lat: coordLat,
      long: coordLong,
      order_by: 'nearest',
      is_not_ethical: true,
    });
  }, [coordLat, coordLong]);

  useEffect(() => {
    if (!error) {
      return;
    }

    if (error instanceof ApplicationError) {
      notifications.show({
        title: error.name,
        message: error.message,
        color: 'red',
      });
      return;
    }

    notifications.show({
      title: 'Error',
      message: 'Terjadi kesalahan saat memuat data rekomendasi produk.',
      color: 'red',
    });
  }, [error]);

  return (
    <SimpleGrid
      cols={{ base: 2, md: 3, xl: 5 }}
      spacing={{ base: 'sm', lg: 'lg' }}
      verticalSpacing={{ base: 'sm', lg: 'lg' }}
      mb="xl"
    >
      {isLoading
        ? Array.from({ length: PAGE_SIZE }).map((_, i) => (
            <ProductCardSkeleton key={i} />
          ))
        : products.map((product, idx) => (
            <ProductCard key={idx} product={product} />
          ))}
    </SimpleGrid>
  );
}
